import { DnsOutlined } from '@mui/icons-material';
import { Badge, Box, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import React, { memo } from 'react';
import { Handle, Position, } from 'react-flow-renderer';
import styled from 'styled-components';
import ListMenuContext, { useMenuContext } from './MenuContext'
import theme from '../theme'
import HostHoverCard from './HostHoverCard'
// label_location: 0=bottom, 1=left, 2=right, 3=top (Zabbix padrao)
function labelPositionSx(loc) {
  switch (loc) {
    case 1: return { right: '100%', top: '50%', transform: 'translateY(-50%)', mr: 0.5 };
    case 2: return { left: '100%', top: '50%', transform: 'translateY(-50%)', ml: 0.5 };
    case 3: return { left: '50%', bottom: '100%', transform: 'translateX(-50%)', mb: 0.3 };
    default: return { left: '50%', top: '100%', transform: 'translateX(-50%)', mt: 0.3 };
  }
}

const Node = styled.div`
padding: 1px;
border-radius: 5px;
background: ${(props) => props.theme.nodeBg};
color: ${(props) => props.theme.nodeColor};
border: 0px solid ${(props) => (props.selected ? props.theme.primary : props.theme.nodeBorder)};

.react-flow__handle {
  background: ${(props) => props.theme.primary};
  width: 0px;
  height: 0px;
  border: 0px;
  
  border-radius: 20px;
}

.react-flow__handle{
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  }
  
  
  `;


export default memo(({ data, selected }) => {
  const MenuContext = useMenuContext()

  const [isOffline, setIsOffline] = React.useState(false);
  const [problems, setProblems] = React.useState(data.problems);
  const [hasOtherAlarms, setHasOtherAlarms] = React.useState(false);
  const [hoverAnchor, setHoverAnchor] = React.useState(null);
  const hoverTimer = React.useRef(null);
  const isInsideCard = React.useRef(false);

  React.useEffect(() => {
    setProblems(data.problems)
    setIsOffline(data.problems?.filter(p => p.name === "Indisponível por PING").length > 0);
    setHasOtherAlarms(data.problems?.filter(p => p.name !== "Indisponível por PING").length > 0);
  }, [data.problems]);

  const handleMouseEnter = (e) => {
    clearTimeout(hoverTimer.current);
    hoverTimer.current = setTimeout(() => {
      setHoverAnchor(e.currentTarget);
    }, 300);
  };

  const handleMouseLeave = () => {
    clearTimeout(hoverTimer.current);
    hoverTimer.current = setTimeout(() => {
      if (!isInsideCard.current) setHoverAnchor(null);
    }, 100);
  };

  const handleCardEnter = () => {
    clearTimeout(hoverTimer.current);
    isInsideCard.current = true;
  };

  const handleCardLeave = () => {
    isInsideCard.current = false;
    setHoverAnchor(null);
  };

  return (
    <>
      <Box
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={() => MenuContext.isOpen ? MenuContext.setisOpen(false) : ''}
        onContextMenu={(e) => {
          e.preventDefault();
          MenuContext.isOpen ? MenuContext.setisOpen(false) : MenuContext.setStatus({ open: true, x: e.clientX, y: e.clientY })
          if (!MenuContext.isOpen) {
            MenuContext.setStatus({ open: true, x: e.clientX, y: e.clientY })
            MenuContext.setPayload({
              cod_empresa: data.cod_empresa,
              ip: data.ip,
              name: data.label
            })
          }
        }}
      >
        <Node selected={selected}>
          <Handle type="target" position={Position.Left} />

          {data.label == '' ? '' : <>
            <Box display={'flex'} justifyContent={'center'}>
              <Badge badgeContent={isOffline ? 0 : data?.problems.length} color="warning" sx={{
                "& .MuiBadge-badge": {
                  color: 'white',
                  backgroundColor: red[900],
                }
              }}>
                  {data.iconid_on  &&  data.iconid_off  ? <CustomIcon img={data.status  ?  problems.length> 0? data.iconid_on: data.iconid_off : data.iconid_disabled} /> :
                    data.iconid_off ? <CustomIcon img={data.iconid_off}/> :  <DnsOutlined />
                  }
              </Badge>
            </Box>
          </>}
          <Handle type="source" position={Position.Left} />
        </Node>

        {data.label == '' ? '' :
          <Box position={'absolute'}
            sx={{
              width: 120,
              textAlign: 'center',
              pointerEvents: 'auto',
              ...labelPositionSx(data.label_location),
            }}
          >
            <Typography
              fontSize={9}
              noWrap
              sx={{
                color: theme.palette.mode === 'dark' ? '#e0e0e0' : '#222',
                textShadow: theme.palette.mode === 'dark'
                  ? '0 0 3px #000, 0 0 6px #000, 1px 1px 2px #000'
                  : '0 0 3px #fff, 0 0 6px #fff, 1px 1px 2px #fff',
                fontWeight: 500,
                lineHeight: 1.2,
              }}
            >
              {data.label}
            </Typography>
            {data.ip && (
              <Typography
                fontSize={8}
                noWrap
                sx={{
                  color: theme.palette.mode === 'dark' ? '#bbb' : '#555',
                  textShadow: theme.palette.mode === 'dark'
                    ? '0 0 3px #000, 0 0 5px #000'
                    : '0 0 3px #fff, 0 0 5px #fff',
                  lineHeight: 1.2,
                }}
              >
                {data.ip}
              </Typography>
            )}
          </Box>
        }
      </Box>

      <HostHoverCard
        open={Boolean(hoverAnchor)}
        anchorEl={hoverAnchor}
        data={data}
        problems={problems}
        cod_empresa={data.cod_empresa}
        onMouseEnter={handleCardEnter}
        onMouseLeave={handleCardLeave}
      />
    </>
  );
});

const CustomIcon = ({ img }) => {
  return (
    <span>
      <img src={"data:image/png;base64," + img} style={{ width: 32, height: 32, objectFit: 'contain' }} />
    </span>
  )
}